<template>
  <h3
    class="page-title py-2 my-auto text-truncate font-weight-medium text-dark"
  >
    <span class="px-1 bg-primary mr-2"></span>
    <slot></slot>
  </h3>
</template>